import config from 'SRC/config/config.yaml'

export const headerTopLinks = config.header.topLinks.map((item, index) => ({
  id: index + 1,
  link: item.link,
  icoClass: item.icoClass,
  iconSvg: item.iconSvg,
  text: item.text
}))
